import React from 'react';
import BaseEntityList from './BaseEntityList';
import { EntityDesc } from './BaseAddEntityPopup/BaseAddEntityPopup';
import Terra from 'services/apis/terra/Terra';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/reducer';
import { UserRole } from 'data/terra/UserRole';
import { fetchUserRoles } from 'containers/store/common/actions/FetchUserRoles';

function ListUserRole() {
  const dispatch = useDispatch();
  const { userRoles } = useSelector((state: RootState) => state.common);

  return (
    <BaseEntityList<UserRole>
      entityName="UserRole"
      entities={userRoles}
      itemsPerRow={6}
      onEntitySelected={() => {}}
      onSaveEntity={async (desc: EntityDesc) => {
        return Terra.user.addUserRole(desc);
      }}
      onSaveEntityResult={result => {
        if (result.isSuccess()) {
          dispatch(fetchUserRoles());
        }
      }}
    />
  );
}

export default ListUserRole;
